import { Button } from '@medly-components/core';
import styled from 'styled-components';

export const FilterHeaderStyled = styled('div')`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 2.4rem 0 0.8rem;
    color: ${({ theme }) => theme.colors.grey[800]};
    ${Button.Style} {
        padding: 0;
        color: ${({ theme }) => theme.colors.grey[500]};
    }
`;
